const actions = {
    CREATE_DETAILS_START: 'CREATE_DETAILS_START',
    CREATE_DETAILS_SUCCESS: 'CREATE_DETAILS_SUCCESS',
    CREATE_DETAILS_FAILURE: 'CREATE_DETAILS_FAILURE',

    DELETE_DETAILS_START: 'DELETE_DETAILS_START',
    DELETE_DETAILS_SUCCESS: 'DELETE_DETAILS_SUCCESS',
    DELETE_DETAILS_FAILURE: 'DELETE_DETAILS_FAILURE',

    EDIT_DETAILS_START: 'EDIT_DETAILS_START',
    EDIT_DETAILS_SUCCESS: 'EDIT_DETAILS_SUCCESS',
    EDIT_DETAILS_FAILURE: 'EDIT_DETAILS_FAILURE',

    READ_DETAILS_START: 'READ_DETAILS_START',
    READ_DETAILS_SUCCESS: 'READ_DETAILS_SUCCESS',
    READ_DETAILS_FAILURE: 'READ_DETAILS_FAILURE',

    GET_DETAILS_START: 'GET_DETAILS_START',
    GET_DETAILS_SUCCESS: 'GET_DETAILS_SUCCESS',
    GET_DETAILS_FAILURE: 'GET_DETAILS_FAILURE',

    IMPORT_START: 'IMPORT_START',
    IMPORT_SUCCESS: 'IMPORT_SUCCESS',
    IMPORT_FAILURE: 'IMPORT_FAILURE',

    PDFGENERATE_START: 'PDFGENERATE_START',
    PDFGENERATE_SUCCESS: 'PDFGENERATE_SUCCESS',
    PDFGENERATE_FAILURE: 'PDFGENERATE_FAILURE',

    EXPORT_START: 'EXPORT_START',
    EXPORT_SUCCESS: 'EXPORT_SUCCESS',
    EXPORT_FAILURE: 'EXPORT_FAILURE',

    UPDATE_START: 'UPDATE_START',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',

    CLEAR_CRUD_DETAILS_START: 'CLEAR_CRUD_DETAILS_START',
    CLEAR_CRUD_DETAILS_SUCCESS: 'CLEAR_CRUD_DETAILS_SUCCESS',

    CLEAR_GET_DETAILS_START: 'CLEAR_GET_DETAILS_START',
    CLEAR_GET_DETAILS_SUCCESS: 'CLEAR_GET_DETAILS_SUCCESS'
};

export default actions;